// expects the hour as a number between 0 and 24

import { Labels } from "./Translations"

export function timeDependingGreeting(hour: number): string {
    const {
        GreetingEvening,
        GreetingNight,
        GreetingMorning,
        GreetingDefault,
        GreetingAfternoon,
    } = Labels
    if (hour >= 6 && hour < 12) {
        return GreetingMorning
    } else if (hour >= 12 && hour < 17) {
        return GreetingAfternoon
    } else if (hour >= 17 && hour < 24) {
        return GreetingEvening
    } else if (hour >= 0 && hour < 6) {
        return GreetingNight
    } else {
        return GreetingDefault
    }
}
